import React from 'react';

import { ClockIcon } from '../../icons';
import { formatBroadcastDateWithPrefix } from '../../utils/date/date.i18n.utils';
import { isDateInTheFuture } from '../../utils/date/date.utils';
import { DialogProps } from '../coverPage/coverpage.types';

import { PlayerDialog } from './PlayerDialog';

export const PlayerFutureAssetDialog: React.FC<DialogProps['FutureAsset']> = ({ broadcastedTime, posterUrl }) => {
  let header: string | JSX.Element = 'Dette programmet er dessverre ikke tilgjengelig.';
  let description = '';
  if (broadcastedTime) {
    const isFutureAsset = isDateInTheFuture(broadcastedTime);
    description = formatBroadcastDateWithPrefix(broadcastedTime);
    if (isFutureAsset) {
      header = (
        <>
          <ClockIcon iconSize="large" style={{ width: '5rem', height: '5rem' }} />
          <span className="sr-only">Programmet har ikke blitt sendt enda, så du har noe å glede deg til!</span>
        </>
      );
    } else {
      header = 'Dette programmet er ikke tilgjengelig lenger.';
    }
  }

  return <PlayerDialog heading={header} footer={description} posterUrl={posterUrl} />;
};
